import { render, staticRenderFns } from "./ReviewConsentDetails.vue?vue&type=template&id=1196d1af"
import script from "./ReviewConsentDetails.vue?vue&type=script&lang=js"
export * from "./ReviewConsentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports